module.exports = __webpack_public_path__ + "img/77ne.c1d23e37.svg";